import React from 'react';
import NotFound from '../components/notfound/NotFound';

/**
 * @author Germán Martínez
 */
class Route404 extends React.Component
{
    render()
    {
        return <NotFound/>;
    }
};
export default Route404;
